var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("MEMBER")]),_c('h4',[_vm._v("A Principal and/or Dependent who is eligible, has been accepted for membership by HMI after complying with the Eligibility provision, and is currently enrolled under this Agreement.")])])
}]

export { render, staticRenderFns }